import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ROUTES } from '@/constants';

function isLikelyMobileUserAgent(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = String(navigator.userAgent || '').toLowerCase();
  return /android|iphone|ipad|ipod|mobile/.test(ua);
}

/**
 * Redirecionamento “smart” para a página financeira:
 * - Mobile: tenta abrir o app via deep link, com fallback para web.
 * - Desktop: vai direto para o web.
 *
 * Observação: o retorno pós-login é garantido via `?redirect=` no Login/ProtectedRoute.
 */
const GoFinancePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tab = String(searchParams.get('tab') || 'plan').trim().toLowerCase() || 'plan';

  useEffect(() => {
    const webUrl = `${ROUTES.APP_FINANCE}?tab=${encodeURIComponent(tab)}`;
    const deepLink = `vover://finance?tab=${encodeURIComponent(tab)}`;

    if (!isLikelyMobileUserAgent()) {
      window.location.replace(webUrl);
      return;
    }

    // Tenta abrir o app primeiro; se não abrir, cai no web.
    const t = window.setTimeout(() => {
      window.location.replace(webUrl);
    }, 900);

    // Alguns browsers bloqueiam; ainda assim tentamos.
    window.location.href = deepLink;

    return () => window.clearTimeout(t);
  }, [tab]);

  return null;
};

export default GoFinancePage;

